module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_5012.d6fc35f8.png";